import { parseLocalDate } from '@taler/domain'

export const ACCOUNT_CLASSES = ['ASSET', 'LIABILITY', 'INCOME', 'EXPENSE', 'EQUITY'] as const

/** Spending and income are read by month or by week - the granularities a reader actually
 * checks a period-over-period trend by. Day is too noisy and year too coarse for "did I
 * open this month", so this screen offers neither, unlike the buckets above. */
export const PERIOD_ROLLUP_BUCKETS = ['WEEK', 'MONTH'] as const
export const PERIOD_ROLLUP_CLASSES = ['EXPENSE', 'INCOME'] as const

export function firstValue(raw: unknown): string | undefined {
  const value = Array.isArray(raw) ? raw[0] : raw
  return typeof value === 'string' && value !== '' ? value : undefined
}

export function parseClassParam(
  raw: unknown,
  fallback: (typeof ACCOUNT_CLASSES)[number],
): (typeof ACCOUNT_CLASSES)[number] {
  const candidate = firstValue(raw)
  return candidate !== undefined && (ACCOUNT_CLASSES as readonly string[]).includes(candidate)
    ? (candidate as (typeof ACCOUNT_CLASSES)[number])
    : fallback
}

export function parsePeriodRollupClassParam(
  raw: unknown,
  fallback: (typeof PERIOD_ROLLUP_CLASSES)[number],
): (typeof PERIOD_ROLLUP_CLASSES)[number] {
  const candidate = firstValue(raw)
  return candidate !== undefined && (PERIOD_ROLLUP_CLASSES as readonly string[]).includes(candidate)
    ? (candidate as (typeof PERIOD_ROLLUP_CLASSES)[number])
    : fallback
}

export function parsePeriodRollupBucketParam(
  raw: unknown,
  fallback: (typeof PERIOD_ROLLUP_BUCKETS)[number],
): (typeof PERIOD_ROLLUP_BUCKETS)[number] {
  const candidate = firstValue(raw)
  return candidate !== undefined && (PERIOD_ROLLUP_BUCKETS as readonly string[]).includes(candidate)
    ? (candidate as (typeof PERIOD_ROLLUP_BUCKETS)[number])
    : fallback
}

export function parseOptionalDateParam(raw: unknown): string | undefined {
  const candidate = firstValue(raw)
  if (candidate === undefined) return undefined
  try {
    parseLocalDate(candidate)
    return candidate
  } catch {
    return undefined
  }
}

export function parseDateParam(raw: unknown, fallback: string): string {
  return parseOptionalDateParam(raw) ?? fallback
}

/** ISO dates order lexically, so a plain comparison is the date comparison. */
export function clampToToday(value: string, today: string): string {
  return value > today ? today : value
}
